export default {
    "en": {
        "All_Features_Body_Title1": "Packed with features",
        "All_Features_Body_Title1_Description1": "Children can choose different game modes for a personalized and<br>interactive learning experience. Grownups have the option to monitor<br>progress and customize settings.",
        "All_Features_Body_Title1_Description1_Subtitle1": "Daily Adventure",
        "All_Features_Body_Title1_Description1_Subtitle2": "Free Choice",
        "All_Features_Body_Title1_Description1_Subtitle3": "Mission",
        "All_Features_Body_Title1_Description1_Subtitle4": "Monster Collection",
        "All_Features_Body_Title1_Description1_Subtitle5": "Language & Accessibility",
        "All_Features_Body_Title1_Description1_Subtitle6": "Parents Page",
        "All_Features_Body_Title1_Subtitle1": "Daily Adventure",
        "All_Features_Body_Title1_Subtitle1_Description1": "10-15 minutes of daily practice.",
        "All_Features_Body_Title1_Subtitle1_Description2": "Aligned with your child’s age and skill level.",
        "All_Features_Body_Title1_Subtitle1_Description3": "Reaching Level E unlocks the laboratory theme, with increased challenge for more advanced learners.",
        "All_Features_Body_Title1_Subtitle1_Button1": "List of levels",
        "All_Features_Body_Title1_Subtitle2": "Free Choice",
        "All_Features_Body_Title1_Subtitle2_Description1": "60+ multi-level games to-date, with more to come!",
        "All_Features_Body_Title1_Subtitle2_Description2": "Kids can pick and play their favorite math games<br>at the difficulty level that’s right for them.",
        "All_Features_Body_Title1_Subtitle2_Button1": "List of games",
        "All_Features_Body_Title1_Subtitle2_GameName1": "Counting",
        "All_Features_Body_Title1_Subtitle2_GameName2": "Bakery Math",
        "All_Features_Body_Title1_Subtitle2_GameName3": "Falling Blocks",
        "All_Features_Body_Title1_Subtitle2_GameName4": "Equation Maker",
        "All_Features_Body_Title1_Subtitle2_GameName5": "Little Farm",
        "All_Features_Body_Title1_Subtitle2_GameName6": "Matrix",
        "All_Features_Body_Title1_Subtitle2_GameName7": "Train Time",
        "All_Features_Body_Title1_Subtitle2_GameName8": "Shape Tracing",
        "All_Features_Body_Title1_Subtitle2_GameDescription1": "Count fruits and vegetables by ones, twos,<br>fives and tens!",
        "All_Features_Body_Title1_Subtitle2_GameDescription2": "Help the mouse and elephant order numbers<br>and shapes on the circus train.",
        "All_Features_Body_Title1_Subtitle2_GameDescription3": "Use the ten-frame to add and subtract numbers<br>from 0 to 20.",
        "All_Features_Body_Title1_Subtitle2_GameDescription4": "Become a master at creating number sentences<br>for addition, subtraction, and multiplication.",
        "All_Features_Body_Title1_Subtitle2_GameDescription5": "Watch carefully! The animals enter and exit the barn,<br>and it’s up to you to remember who is left inside.",
        "All_Features_Body_Title1_Subtitle2_GameDescription6": "Figure out where all the missing pieces belong in<br>this colorful problem-solving game!",
        "All_Features_Body_Title1_Subtitle2_GameDescription7": "What time does the train leave? Match the numbers<br>to the clock to watch the train take off!",
        "All_Features_Body_Title1_Subtitle2_GameDescription8": "Draw and name 10 common shapes!",
        "All_Features_Body_Title1_Subtitle3": "Mission",
        "All_Features_Body_Title1_Subtitle3_Description1": "70+ standards-aligned missions from<br>simple counting all the way to multiplication.",
        "All_Features_Body_Title1_Subtitle3_Description2": "At Level E, kids also gain access to<br>Challenge Library, a selection of fun quizzes<br>that gauge foundational skill mastery.",
        "All_Features_Body_Title1_Subtitle3_Agegroup1": "Pre-kindergarten",
        "All_Features_Body_Title1_Subtitle3_Agegroup2": "Mission 1-7",
        "All_Features_Body_Title1_Subtitle3_Agegroup3": "Kindergarten",
        "All_Features_Body_Title1_Subtitle3_Agegroup4": "Mission 8-28",
        "All_Features_Body_Title1_Subtitle3_Agegroup5": "1st Grade",
        "All_Features_Body_Title1_Subtitle3_Agegroup6": "Mission 29-50",
        "All_Features_Body_Title1_Subtitle3_Agegroup7": "2nd Grade",
        "All_Features_Body_Title1_Subtitle3_Agegroup8": "Mission 51-74",
        "All_Features_Body_Title1_Subtitle3_Button1": "List of missions",
        "All_Features_Body_Title1_Subtitle4": "Monster Collection",
        "All_Features_Body_Title1_Subtitle4_Description1": "Monster Quizzes let kids build fun monster collections by completing quizzes that support mastery of early elementary math!",
        "All_Features_Body_Title1_Subtitle5": "Accessibility",
        "All_Features_Body_Title1_Subtitle5_Description1": "8 language settings available.",
        "All_Features_Body_Title1_Subtitle5_Description2": "Left-handed mode, OpenDyslexic font, help<br>button, and simplified keypad input <br>allow Todo Math to be tailored to each<br>child’s needs.",
        "All_Features_Body_Title1_Subtitle6": "Parents Page",
        "All_Features_Body_Title1_Subtitle6_Description1": "Set child’s level, tailor settings, and track<br>learning progress.",
        "All_Features_Body_Title1_Subtitle6_Description2": "Up to two children can be added."
    },
    "ko": {
        "All_Features_Body_Title1": "다양한 기능이 가득",
        "All_Features_Body_Title1_Description1": "아이는 여러 활동을 통해 자신에게 맞는 인터랙티브한 학습을 하고,<br>어른들은 아이의 진도를 확인하며 각종 설정을 변경할 수 있어요.",
        "All_Features_Body_Title1_Description1_Subtitle1": "오늘의 모험",
        "All_Features_Body_Title1_Description1_Subtitle2": "자유 선택 모드",
        "All_Features_Body_Title1_Description1_Subtitle3": "미션 모드",
        "All_Features_Body_Title1_Description1_Subtitle4": "몬스터를 잡아라!",
        "All_Features_Body_Title1_Description1_Subtitle5": "언어 및 접근성",
        "All_Features_Body_Title1_Description1_Subtitle6": "부모 페이지",
        "All_Features_Body_Title1_Subtitle1": "오늘의 모험",
        "All_Features_Body_Title1_Subtitle1_Description1": "매일 10~15분의 꾸준한 연습이 가능해요.",
        "All_Features_Body_Title1_Subtitle1_Description2": "아이의 연령대와 레벨에 맞추어 제공해요.",
        "All_Features_Body_Title1_Subtitle1_Description3": "레벨E부터는 도전과제 연구소로 레벨 업!",
        "All_Features_Body_Title1_Subtitle1_Button1": "레벨 목록",
        "All_Features_Body_Title1_Subtitle2": "자유 선택 모드",
        "All_Features_Body_Title1_Subtitle2_Description1": "여러 수준으로 풀 수 있는 게임이 약 60가지 이상 준비되어 있고,<br>계속 추가되고 있어요.",
        "All_Features_Body_Title1_Subtitle2_Description2": "아이들이 원하는 게임을 골라 원하는 레벨에서<br>플레이할 수 있어요!",
        "All_Features_Body_Title1_Subtitle2_Button1": "게임 목록",
        "All_Features_Body_Title1_Subtitle2_GameName1": "수 세기",
        "All_Features_Body_Title1_Subtitle2_GameName2": "쿠키 만들기",
        "All_Features_Body_Title1_Subtitle2_GameName3": "블록 연산",
        "All_Features_Body_Title1_Subtitle2_GameName4": "수식 만들기",
        "All_Features_Body_Title1_Subtitle2_GameName5": "작은 농장",
        "All_Features_Body_Title1_Subtitle2_GameName6": "매트릭스",
        "All_Features_Body_Title1_Subtitle2_GameName7": "시계기차",
        "All_Features_Body_Title1_Subtitle2_GameName8": "도형 따라그리기",
        "All_Features_Body_Title1_Subtitle2_GameDescription1": "1, 2, 5, 10 단위로 과일과 채소를 세어보아요!",
        "All_Features_Body_Title1_Subtitle2_GameDescription2": "코끼리와 쥐를 도와서 서커스 기차 위에 나타나는<br>숫자와 도형을 맞춰보세요!",
        "All_Features_Body_Title1_Subtitle2_GameDescription3": "10칸 연산을 활용하여 숫자 0~20 덧셈과<br>뺄셈을 해보아요.",
        "All_Features_Body_Title1_Subtitle2_GameDescription4": "덧셈, 뺄셈, 곱셈 연산식 만들기의 달인에 도전!",
        "All_Features_Body_Title1_Subtitle2_GameDescription5": "동물들이 헛간을 드나드는 것을 잘 지켜보고,<br>누가 안에 남아있는지 맞춰보세요.",
        "All_Features_Body_Title1_Subtitle2_GameDescription6": "알록달록한 문제해결 게임! 어떤 조각들을 어느<br>자리에 맞추면 좋을지 생각해봐요!",
        "All_Features_Body_Title1_Subtitle2_GameDescription7": "기차가 몇 시에 출발할까요? 시계의 숫자를 맞춰<br>기차가 출발하도록 도와줘요!",
        "All_Features_Body_Title1_Subtitle2_GameDescription8": "10가지 기본 도형을 그리고 이름을 맞춰봐요!",
        "All_Features_Body_Title1_Subtitle3": "미션 모드",
        "All_Features_Body_Title1_Subtitle3_Description1": "표준 교과 과정을 반영한 70가지 이상의<br>미션이 가득",
        "All_Features_Body_Title1_Subtitle3_Description2": "레벨E부터는 도전과제 열람실로 레벨 업!",
        "All_Features_Body_Title1_Subtitle3_Agegroup1": "유아 수학",
        "All_Features_Body_Title1_Subtitle3_Agegroup2": "미션 1~7",
        "All_Features_Body_Title1_Subtitle3_Agegroup3": "유치원",
        "All_Features_Body_Title1_Subtitle3_Agegroup4": "미션 8~28",
        "All_Features_Body_Title1_Subtitle3_Agegroup5": "1학년",
        "All_Features_Body_Title1_Subtitle3_Agegroup6": "미션 29~50",
        "All_Features_Body_Title1_Subtitle3_Agegroup7": "2학년",
        "All_Features_Body_Title1_Subtitle3_Agegroup8": "미션 51~74",
        "All_Features_Body_Title1_Subtitle3_Button1": "미션 목록",
        "All_Features_Body_Title1_Subtitle4": "몬스터를 잡아라!",
        "All_Features_Body_Title1_Subtitle4_Description1": "몬스터 퀴즈로 학습효과를 배가하고 몬스터를 수집하면서<br>기초 수학 실력을 튼튼히!",
        "All_Features_Body_Title1_Subtitle5": "접근성",
        "All_Features_Body_Title1_Subtitle5_Description1": "8개 국어로 토도수학을 사용할 수 있어요.",
        "All_Features_Body_Title1_Subtitle5_Description2": "왼손잡이 모드, 난독용 폰트 (영어버전),<br>도움말 버튼, 단순화된 키패드 등으로<br>다양한 필요를 가진 아이들 모두<br>토도수학을 즐길 수 있어요.",
        "All_Features_Body_Title1_Subtitle6": "부모 페이지",
        "All_Features_Body_Title1_Subtitle6_Description1": "아이의 진도에 맞게 레벨과 각종 옵션들을 설정하고<br>진도를 확인할 수 있어요.",
        "All_Features_Body_Title1_Subtitle6_Description2": "최대 두 명까지 사용자를 추가할 수 있어요."
    },
    "cn": {
        "All_Features_Body_Title1": "系统介绍",
        "All_Features_Body_Title1_Description1": "使用者可以选择不同的游戏模块，根据自己的兴趣来体验。<br>家长可以随时监控进度并设置使用时间。",
        "All_Features_Body_Title1_Description1_Subtitle1": "每日探险",
        "All_Features_Body_Title1_Description1_Subtitle2": "自由模式",
        "All_Features_Body_Title1_Description1_Subtitle3": "任务",
        "All_Features_Body_Title1_Description1_Subtitle4": "怪兽收集",
        "All_Features_Body_Title1_Description1_Subtitle5": "语言和辅助功能",
        "All_Features_Body_Title1_Description1_Subtitle6": "家长页面",
        "All_Features_Body_Title1_Subtitle1": "每日探险",
        "All_Features_Body_Title1_Subtitle1_Description1": "星星是一天探险的最后一关",
        "All_Features_Body_Title1_Subtitle1_Description2": "每3个星星关后将有一个奖杯关",
        "All_Features_Body_Title1_Subtitle1_Description3": "完成奖杯关即可抓到小怪兽",
        "All_Features_Body_Title1_Subtitle1_Description4": "抓齐所有小怪兽将自动升级，可反复挑战",
        "All_Features_Body_Title1_Subtitle1_Button1": "级别介绍",
        "All_Features_Body_Title1_Subtitle2": "自由模式",
        "All_Features_Body_Title1_Subtitle2_Description1": "已有60多个不同玩法的游戏，且持续更新中！",
        "All_Features_Body_Title1_Subtitle2_Description2": "孩子们可以挑选他们想要的游戏<br>在他们想要的难易程度的发挥。",
        "All_Features_Body_Title1_Subtitle2_Button1": "游戏列表",
        "All_Features_Body_Title1_Subtitle2_GameName1": "算数",
        "All_Features_Body_Title1_Subtitle2_GameName2": "烘焙数学",
        "All_Features_Body_Title1_Subtitle2_GameName3": "下降的积木",
        "All_Features_Body_Title1_Subtitle2_GameName4": "方程式生成器",
        "All_Features_Body_Title1_Subtitle2_GameName5": "小农场",
        "All_Features_Body_Title1_Subtitle2_GameName6": "矩阵",
        "All_Features_Body_Title1_Subtitle2_GameName7": "火车时间",
        "All_Features_Body_Title1_Subtitle2_GameName8": "形状跟踪",
        "All_Features_Body_Title1_Subtitle2_GameDescription1": "用一、二、五和十来数水果和蔬菜！",
        "All_Features_Body_Title1_Subtitle2_GameDescription2": "在马戏团火车上帮助老鼠大象给数字和图形排序。",
        "All_Features_Body_Title1_Subtitle2_GameDescription3": "使用十个小方格加减从0到20的数字。",
        "All_Features_Body_Title1_Subtitle2_GameDescription4": "成为用加、减和乘法创造数字的大师。",
        "All_Features_Body_Title1_Subtitle2_GameDescription5": "看仔细哦！ 动物们会进出畜棚，<br> 而要靠您记住谁还在里面。",
        "All_Features_Body_Title1_Subtitle2_GameDescription6": "看看缺失的地方应该放入什么样的方块！",
        "All_Features_Body_Title1_Subtitle2_GameDescription7": "火车什么时候开？<br> 填上与时钟匹配的数字 然后观看火车出发",
        "All_Features_Body_Title1_Subtitle2_GameDescription8": "绘制并命名10种常见形状",
        "All_Features_Body_Title1_Subtitle3": "任务",
        "All_Features_Body_Title1_Subtitle3_Description1": "70多项标准排列的任务，<br>从简单数数到统计图表。",
        "All_Features_Body_Title1_Subtitle3_Description2": "在 E 级及以上，将增加<br>挑战实验室模块。",
        "All_Features_Body_Title1_Subtitle3_Agegroup1": "Level A",
        "All_Features_Body_Title1_Subtitle3_Agegroup2": "任务 1–7",
        "All_Features_Body_Title1_Subtitle3_Agegroup3": "Level B/C",
        "All_Features_Body_Title1_Subtitle3_Agegroup4": "任务 8–28",
        "All_Features_Body_Title1_Subtitle3_Agegroup5": "Level D/E",
        "All_Features_Body_Title1_Subtitle3_Agegroup6": "任务 29–50",
        "All_Features_Body_Title1_Subtitle3_Agegroup7": "Level F/G",
        "All_Features_Body_Title1_Subtitle3_Agegroup8": "任务 51–74",
        "All_Features_Body_Title1_Subtitle3_Button1": "任务列表",
        "All_Features_Body_Title1_Subtitle4": "怪兽收集",
        "All_Features_Body_Title1_Subtitle4_Description1": "通过小怪兽关可以收集小怪兽<br>小怪兽数量反映孩子的级别进度",
        "All_Features_Body_Title1_Subtitle5": "辅助功能",
        "All_Features_Body_Title1_Subtitle5_Description1": "提供8种语言设置。",
        "All_Features_Body_Title1_Subtitle5_Description2": "左手模式，准对阅读障碍者的字体，帮助<br>按钮和简化的键盘输入样式<br>允许都都数学根据每个<br>孩子的需求进行定制。",
        "All_Features_Body_Title1_Subtitle6": "家长页面",
        "All_Features_Body_Title1_Subtitle6_Description1": "设置孩子的水平级别，了解学习进度<br>设置，并跟踪学习进度",
        "All_Features_Body_Title1_Subtitle6_Description2": "最多可设置两个孩子学习存档。"
    },
    "ja": {
        "All_Features_Body_Title1": "多様な機能が充実",
        "All_Features_Body_Title1_Description1": "様々なゲームモードで自分に合ったインタラクティブな学習を経験できます。保護者はお子さまの進度を確認し、各種設定を変更できます。",
        "All_Features_Body_Title1_Description1_Subtitle1": "きょうのぼうけん",
        "All_Features_Body_Title1_Description1_Subtitle2": "フリーモード",
        "All_Features_Body_Title1_Description1_Subtitle3": "ミッションモード",
        "All_Features_Body_Title1_Description1_Subtitle4": "モンスターコレクション",
        "All_Features_Body_Title1_Description1_Subtitle5": "言語とアクセシビリティ",
        "All_Features_Body_Title1_Description1_Subtitle6": "保護者ページ",
        "All_Features_Body_Title1_Subtitle1": "きょうのぼうけん",
        "All_Features_Body_Title1_Subtitle1_Description1": "毎日10〜15分コツコツと学習が可能です。",
        "All_Features_Body_Title1_Subtitle1_Description2": "お子さまの年齢とレベルに合わせて提供します。",
        "All_Features_Body_Title1_Subtitle1_Description3": "レベルEからはチャレンジ ラボにレベルアップ！",
        "All_Features_Body_Title1_Subtitle1_Button1": "レベルリスト",
        "All_Features_Body_Title1_Subtitle2": "フリーモード",
        "All_Features_Body_Title1_Subtitle2_Description1": "様々なレベルで構成された60種以上のゲームが準備されており、新しいゲームも少しずつ追加されています。",
        "All_Features_Body_Title1_Subtitle2_Description2": "お子さまが好きなゲームを選び、好きなレベルからプレイできます！",
        "All_Features_Body_Title1_Subtitle2_Button1": "ゲームリスト",
        "All_Features_Body_Title1_Subtitle2_GameName1": "くだものかぞえ",
        "All_Features_Body_Title1_Subtitle2_GameName2": "クッキーづくり",
        "All_Features_Body_Title1_Subtitle2_GameName3": "ブロックけいさん",
        "All_Features_Body_Title1_Subtitle2_GameName4": "しきづくり",
        "All_Features_Body_Title1_Subtitle2_GameName5": "リトルファーム",
        "All_Features_Body_Title1_Subtitle2_GameName6": "マトリックス",
        "All_Features_Body_Title1_Subtitle2_GameName7": "トレインタイム",
        "All_Features_Body_Title1_Subtitle2_GameName8": "ずけいなぞり",
        "All_Features_Body_Title1_Subtitle2_GameDescription1": "1、2、5、10単位で果物と野菜を数えてみよう！",
        "All_Features_Body_Title1_Subtitle2_GameDescription2": "ねずみとゾウが、サーカス列車の上の数字と図形の順序を正しく入れられるように手助けしよう！",
        "All_Features_Body_Title1_Subtitle2_GameDescription3": "10マスフレームを活用して、0〜20の足し算引き算をしてみよう。",
        "All_Features_Body_Title1_Subtitle2_GameDescription4": "足し算、引き算、掛け算の式作りの達人に挑戦！",
        "All_Features_Body_Title1_Subtitle2_GameDescription5": "よ〜く見てみよう！動物たちが小屋に入ったり出たりしている間、誰が中に残っているのかしっかりと記憶しておこう。",
        "All_Features_Body_Title1_Subtitle2_GameDescription6": "空いているマスの問題解決ゲーム！どこにどんなカードを入れたらいいか考えてみよう！",
        "All_Features_Body_Title1_Subtitle2_GameDescription7": "列車は何時に出発するかな？時計の数字を合わせて、列車が出発できるように手助けしよう！",
        "All_Features_Body_Title1_Subtitle2_GameDescription8": "10種類の基本図形と名前を当ててみよう！",
        "All_Features_Body_Title1_Subtitle3": "ミッションモード",
        "All_Features_Body_Title1_Subtitle3_Description1": "標準教科過程を反映した70種以上のミッションがたっぷり",
        "All_Features_Body_Title1_Subtitle3_Description2": "レベルEからはチャレンジ ライブラリーにレベルアップ！",
        "All_Features_Body_Title1_Subtitle3_Agegroup1": "幼児",
        "All_Features_Body_Title1_Subtitle3_Agegroup2": "ミッション1~7",
        "All_Features_Body_Title1_Subtitle3_Agegroup3": "幼稚園",
        "All_Features_Body_Title1_Subtitle3_Agegroup4": "ミッション8~28",
        "All_Features_Body_Title1_Subtitle3_Agegroup5": "1年生",
        "All_Features_Body_Title1_Subtitle3_Agegroup6": "ミッション29~50",
        "All_Features_Body_Title1_Subtitle3_Agegroup7": "2年生",
        "All_Features_Body_Title1_Subtitle3_Agegroup8": "ミッション51~74",
        "All_Features_Body_Title1_Subtitle3_Button1": "ミッションリスト",
        "All_Features_Body_Title1_Subtitle4": "モンスターコレクション",
        "All_Features_Body_Title1_Subtitle4_Description1": "モンスタークイズで学習の効果をさらに高め、モンスターを集めながら算数の基礎を固めます！",
        "All_Features_Body_Title1_Subtitle5": "アクセシビリティ",
        "All_Features_Body_Title1_Subtitle5_Description1": "トドさんすうは8つの言語でプレイ可能です。",
        "All_Features_Body_Title1_Subtitle5_Description2": "左利きモード、ヘルプボタン、キーパッドモード、難読用フォント（英語バージョン）で、多様なニーズを持った全てのお子さまがトドさんすうを楽しめます。",
        "All_Features_Body_Title1_Subtitle6": "保護者ページ",
        "All_Features_Body_Title1_Subtitle6_Description1": "お子さまに合わせてレベルと各種オプションを設定し、進度をチェックできます。",
        "All_Features_Body_Title1_Subtitle6_Description2": "最大2人まで学習者を追加できます。"
    }
}


// WEBPACK FOOTER //
// ./src/text/features/laptop.js